import { render, staticRenderFns } from "./VehicleDetailsCard.vue?vue&type=template&id=124afe2f"
import script from "./VehicleDetailsCard.vue?vue&type=script&lang=js"
export * from "./VehicleDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetailsCard.vue?vue&type=style&index=0&id=124afe2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports